import { partnerAdminFetch } from '~/api/partnerAdminFetch';
import { ApiError } from '../../action/apiError';
import { Notification, NotificationParams } from '../../types/resources/Notification';

type ResponseType = {
  data: {
    notifications: Notification[];
  };
  headers: Record<string, string>;
};

export async function getPushNotifications(
  signOut?: () => void,
  searchParams?: { page?: string }
): Promise<ResponseType> {
  const queryString = new URLSearchParams(searchParams).toString();
  const response = await partnerAdminFetch(
    `/partner_admins/notifications${queryString ? `?${queryString}` : ''}`,
    {
      method: 'GET',
    },
    signOut
  );

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return {
    data,
    headers: Object.fromEntries(response.headers.entries()),
  };
}

export const createPushNotifications = async (
  data: NotificationParams
): Promise<{ notification: Notification }> => {
  const response = await partnerAdminFetch('/partner_admins/notifications', {
    method: 'POST',
    data: { notification: data },
  });

  if (!response.ok) {
    const errorDetails = await response.json();
    throw new ApiError(
      `HTTP ${response.status} ${response.statusText}`,
      errorDetails.errors || [errorDetails.message]
    );
  }

  return response.json();
};
